import * as React from "react"
import type { SVGProps } from "react"
const SvgMegaphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m11.48 13.77 4.64 2.81V6.33l-4.64 2.8H5.16a.8.8 0 0 0-.62.26.8.8 0 0 0-.26.62v2.88c0 .26.07.43.26.62s.36.26.62.26zm6.08-9.54-.18-.12q-.74-.44-1.46 0l-5 3.02H5.16q-1.2 0-2.03.85a2.8 2.8 0 0 0-.85 2.03v2.88q0 1.2.85 2.04a2.8 2.8 0 0 0 2.03.84H6.6v4.32q0 .61.41 1.03.42.41 1.03.41.6 0 1.03-.41.4-.42.41-1.03v-4.32h1.44l5 3.03q.72.43 1.46 0l.18-.12q.56-.42.56-1.14V5.37q0-.72-.56-1.14m2 2.4a6.4 6.4 0 0 1 2 3.36 7 7 0 0 1 .16 1.46 7 7 0 0 1-.6 2.72 7 7 0 0 1-1 1.54q-.26.3-.56.57z"
    />
  </svg>
)
export default SvgMegaphone
